import axios from "axios";

// export const BaseUrl = "https://api.trippytourguide.com/";
// export const BaseUrl = "https://test-api.trippytourguide.com/";
export const BaseUrl = "https://connect.trippytourguide.com/";
export const ImgUrl = `${BaseUrl}imageUpload/`;

const instance = axios.create({
  baseURL: BaseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (!config.headers) {
      config.headers = {}; // Ensure headers is defined
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: catch HTTP 429 (rate limited) and show a
// user-friendly toast so the admin always gets clear feedback.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 429) {
      const message =
        error?.response?.data?.message ||
        "Too many requests. Please wait a moment and try again.";
      // Dynamically import toast to avoid circular dependency issues.
      // The toast will render via the <ToastContainer /> already in the app.
      import("react-toastify").then(({ toast }) => {
        toast.error(message, { toastId: "rate-limit-429" });
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
